import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-embeddings',
  name: 'LangChain Embeddings',
  description: 'Generate vector embeddings from text using OpenAI or other providers',
  icon: 'Sparkles',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'embeddings', 'ai', 'vector', 'openai'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
